document.addEventListener('change', event => {
  if (event.target.matches('[data-variant-select]')) {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', event.target.value);
    window.location.assign(url.toString());
  }
  if (event.target.matches('[data-sort]')) {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', event.target.value);
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }
});
document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    document.querySelectorAll('.mobile-menu[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  }
});
document.addEventListener('click', event => {
  document.querySelectorAll('.mobile-menu[open]').forEach(menu => { if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false; });
  const step = event.target.closest('[data-qty]');
  if (step) {
    const input = step.parentElement.querySelector('input');
    const min = parseInt(input.min, 10) || 1;
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    const next = (parseInt(input.value, 10) || min) + parseInt(step.dataset.qty, 10);
    input.value = Math.min(max, Math.max(min, next));
  }
});
(() => {
  const addButton = document.querySelector('.product-info .add-button');
  const sticky = document.querySelector('[data-sticky-atc]');
  if (!addButton || !sticky || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(([entry]) => {
    sticky.hidden = entry.isIntersecting;
    document.body.classList.toggle('has-sticky', !entry.isIntersecting);
  }).observe(addButton);
})();
